export type ProjectType = 'App' | 'Website' | 'Game' | 'Agent' | 'Tool' | 'Integration';

export type Brief = {
  description: string;
  type: ProjectType | null;
  name: string;
  detail: string;
  features: string;
};

export type Message = {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  time: string;
};

export const EMPTY_BRIEF: Brief = {
  description: '',
  type: null,
  name: '',
  detail: '',
  features: '',
};

export const PROJECT_TYPES: ProjectType[] = [
  'App',
  'Website',
  'Game',
  'Agent',
  'Tool',
  'Integration',
];
